import { useState } from "react";
import { ModalContext } from "./modalContext";
import type { ModalMap, ModalState } from "./modalTypes";
import { modalRegistry } from "./modalRegistry";

export function ModalProvider({ children }: { children: React.ReactNode }) {
  const [modal, setModal] = useState<ModalState>(null);

  const openModal = <K extends keyof ModalMap>(name: K, props: ModalMap[K]) => {
    setModal({ name, props });
  };

  const closeModal = () => setModal(null);

  const renderModal = () => {
    if (!modal) return null;

    const Component = modalRegistry[modal.name];
    return <Component {...modal.props} closeModal={closeModal} />;
  };

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      {children}

      {modal && (
        <div className="overlay" onClick={closeModal}>
          <div onClick={(e) => e.stopPropagation()}>{renderModal()}</div>
        </div>
      )}
    </ModalContext.Provider>
  );
}
